import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router';

function RouterLocationListener() {
  const location = useLocation();
  const prevLocationRef = useRef(null);

  useEffect(() => {
    (window as any).analytics.page({
      referrer: prevLocationRef.current?.pathname,
    });
    prevLocationRef.current = location;
  }, [location]);

  return <div />;
}

export default RouterLocationListener;
